// TODO: Удалить в CD-225149.
export const NEWBUILDING_CONSULTANT_MESSAGE_BUTTON = 'newbuilding_new_entry_point_webim_desktop';

export const EXPERIMENTS: string[] = [NEWBUILDING_CONSULTANT_MESSAGE_BUTTON];
